/* Jesus PDP — fast static-image build. Theme asset (Horizon-safe).
   Reads config from #jespdp-cfg (JSON). Swaps to pre-baked static images (no live compositing).
   Loads variant data from /products/{handle}.js for sizes/prices/availability/cart. */
(function () {
  var cfgEl = document.getElementById('pdp-cfg');
  if (!cfgEl) return;
  var CFG = JSON.parse(cfgEl.textContent);
  (function(){ function _hb(){ var b=document.getElementById('pdp-boot'); var w=document.querySelector('.pdp-wrap');
    if(w) w.classList.add('pdp-ready'); if(b){ b.style.opacity='0'; b.style.pointerEvents='none'; setTimeout(function(){ if(b) b.style.display='none'; },350); } }
    if(document.readyState==='complete'){ setTimeout(_hb,50); } else { window.addEventListener('load', function(){ setTimeout(_hb,50); }); }
    setTimeout(_hb, 1500); /* FORCE_HIDE_BOOT hard fallback */ })();
  var REVEAL_MS = 350; // minimum shimmer duration before revealing content
  var _bootStart = Date.now();
  function reveal() {
    var wrap = document.querySelector('.pdp-wrap');
    var boot = document.getElementById('pdp-boot');
    if (wrap) wrap.classList.add('pdp-ready');
    if (boot) { boot.classList.add('pdp-boot-hide'); setTimeout(function () { boot.style.display = 'none'; }, 320); }
  }
  function scheduleReveal() { reveal(); }
  var TREATS = CFG.inks;
  var DATA = { tee: null, hoodie: null };
  var g = 'tee', style = CFG.defaultStyle, color = CFG.defaultColor, ink = 'fc', size = null;
  var styleChosen = false, colorChosen = false, inkChosen = false;
  var QV = (function () { try { var v = new URLSearchParams(location.search).get('variant'); return v ? parseInt(v, 10) : null; } catch (e) { return null; } })();
  function el(id) { return document.getElementById(id); }

  function vset(st, c) { var m = CFG.TV[st] || {}; return m[c] || []; }
  function prod() { return DATA[g]; }
  function stylesOf() { if (!prod()) return CFG.styleOrder.slice(); var o = []; CFG.styleOrder.forEach(function (s) { if (prod().variants.some(function (v) { return v.style === s; })) o.push(s); }); return o; }
  function colorsOf() { if (!prod()) return CFG.colorOrder.slice(); var o = []; CFG.colorOrder.forEach(function (c) { if (prod().variants.some(function (v) { return v.color === c; })) o.push(c); }); return o; }
  function _styles() { return styleChosen ? [style] : stylesOf(); }
  function _colors() { return colorChosen ? [color] : colorsOf(); }
  function inkEnabled(t) { var ss = _styles(), cc = _colors(); for (var i = 0; i < ss.length; i++) for (var j = 0; j < cc.length; j++) if (vset(ss[i], cc[j]).indexOf(t) >= 0) return true; return false; }
  function colorEnabled(c) { var ss = _styles(), tt = inkChosen ? [ink] : TREATS; for (var i = 0; i < ss.length; i++) for (var j = 0; j < tt.length; j++) if (vset(ss[i], c).indexOf(tt[j]) >= 0) return true; return false; }
  function styleEnabled(s) { var cc = _colors(), tt = inkChosen ? [ink] : TREATS; for (var i = 0; i < cc.length; i++) for (var j = 0; j < tt.length; j++) if (vset(s, cc[i]).indexOf(tt[j]) >= 0) return true; return false; }
  function effTriple() {
    var ss = _styles(), cc = _colors(), tt = inkChosen ? [ink] : TREATS;
    var ps = styleChosen ? style : (stylesOf().indexOf(style) >= 0 ? style : stylesOf()[0]);
    var pc = colorChosen ? color : CFG.defaultColor; var pt = inkChosen ? ink : null; var best = null;
    for (var i = 0; i < ss.length; i++) for (var j = 0; j < cc.length; j++) for (var k = 0; k < tt.length; k++) {
      var s = ss[i], c = cc[j], t = tt[k]; if (vset(s, c).indexOf(t) < 0) continue;
      var score = (s === ps ? 4 : 0) + (c === pc ? 2 : 0) + (pt && t === pt ? 1 : 0) + ((!pt && t === 'fc') ? 1 : 0);
      if (!best || score > best.score) best = { s: s, c: c, t: t, score: score };
    }
    if (!best) best = { s: ps, c: pc, t: (pt || 'fc') }; return best;
  }
  function effStyle() { return effTriple().s; } function effColor() { return effTriple().c; } function effInk() { return effTriple().t; }

  function imgUrl(gar, st, c, tk) { return CFG.img[gar + '|' + st + '|' + c + '|' + tk] || ''; }
  function setImg() { var u = imgUrl(g, effStyle(), effColor(), effInk()); if (u) el('pdp-hero').src = u; }

  function renderStyle() {
    var r = el('pdp-strow'); r.innerHTML = '';
    stylesOf().forEach(function (s) {
      var b = document.createElement('button'); b.type = 'button'; var ok = styleEnabled(s);
      b.className = 'pdp-stthumb' + (s === effStyle() && ok ? ' on' : '') + (ok ? '' : ' dis'); b.disabled = !ok; b.title = s;
      b.innerHTML = '<img loading="lazy" decoding="async" src="' + (CFG.THUMB[s] || '') + '" alt="' + s + '"><span>' + s + '</span>';
      if (ok) b.onclick = function () { style = s; styleChosen = true; sync(); };
      r.appendChild(b);
    });
    el('pdp-stname').textContent = '\u2014 ' + effStyle();
  }
  function renderInk() {
    var r = el('pdp-inkrow'); r.innerHTML = '';
    TREATS.forEach(function (t) {
      var b = document.createElement('button'); b.type = 'button'; var ok = inkEnabled(t);
      b.className = 'pdp-inkbtn' + (t === effInk() && ok ? ' on' : '') + (ok ? '' : ' dis');
      b.innerHTML = '<span class="pdp-tdot" style="background:' + CFG.inkDot[t] + (t === 'cream' ? ';box-shadow:inset 0 0 0 1px #c9c2b4' : '') + '"></span>' + CFG.inkLabel[t];
      b.disabled = !ok; if (ok) b.onclick = function () { ink = t; inkChosen = true; sync(); };
      r.appendChild(b);
    });
    el('pdp-inkname').textContent = '\u2014 ' + CFG.inkLabel[effInk()];
  }
  function renderColors() {
    var r = el('pdp-sw'); r.innerHTML = '';
    colorsOf().forEach(function (c) {
      var b = document.createElement('button'); b.type = 'button'; b.style.background = CFG.hex[c] || '#ccc';
      if ((CFG.hex[c] || '').toLowerCase() === '#ffffff') b.style.borderColor = '#999';
      var ok = colorEnabled(c); b.className = (c === effColor() && ok ? 'on' : '') + (ok ? '' : ' dis'); b.disabled = !ok; b.title = c;
      if (ok) b.onclick = function () { color = c; colorChosen = true; sync(); };
      r.appendChild(b);
    });
    el('pdp-colname').textContent = '\u2014 ' + effColor();
  }
  function sizesFor() { if (!prod()) return []; return prod().variants.filter(function (v) { return v.color === effColor() && v.style === effStyle(); }).sort(function (a, b) { return CFG.sizeOrder.indexOf(a.size) - CFG.sizeOrder.indexOf(b.size); }); }
  function renderSizes() {
    var r = el('pdp-sz'); r.innerHTML = '';
    sizesFor().forEach(function (v) {
      var b = document.createElement('button'); b.type = 'button'; b.textContent = v.size; b.disabled = !v.available;
      b.className = (v.size === size ? 'on' : ''); b.onclick = function () { size = v.size; syncSize(); };
      r.appendChild(b);
    });
  }
  function curV() { if (!size || !prod()) return null; return prod().variants.find(function (v) { return v.color === effColor() && v.size === size && v.style === effStyle(); }); }
  function syncSize() {
    renderSizes(); var v = curV(); var a = el('pdp-atc');
    if (v) {
      a.textContent = 'Add to cart \u2014 $' + v.price;
      a.onclick = function () {
        a.textContent = 'Adding\u2026';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: v.vid, quantity: 1, properties: { Ink: (CFG.inkLabel[effInk()] || 'Full Color') } }) })
          .then(function () { a.textContent = 'Added \u2713'; return fetch('/cart.js'); })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var evt = new Event('cart:update', { bubbles: true });
            evt.detail = { resource: cart, sourceId: 'ad-pdp-atc', data: { source: 'product-form-component', itemCount: cart.item_count } };
            document.dispatchEvent(evt);
            var dr = document.querySelector('cart-drawer-component'); if (dr && typeof dr.open === 'function') { try { dr.open(); } catch (e) {} }
            setTimeout(syncSize, 1200);
          }).catch(function () { a.textContent = 'Added \u2713'; setTimeout(syncSize, 1500); });
      };
    } else { a.textContent = 'Select a size'; a.onclick = null; }
  }
  function sync() {
    setImg(); renderStyle(); renderInk(); renderColors();
    var p = prod(); if (p) {
      var mn = Math.min.apply(null, p.variants.map(function (v) { return parseFloat(v.price); }));
      var mv = p.variants.filter(function (v) { return parseFloat(v.price) === mn; })[0]; var c = mv && mv.compare ? mv.compare : null;
      el('pdp-price').innerHTML = (c ? '<s>$' + c + '</s>' : '') + '<span>$' + mn.toFixed(2) + '</span>' + (c ? '<span class="pdp-off">20% OFF</span>' : '');
    }
    var keep = size && sizesFor().some(function (v) { return v.size === size && v.available; }); if (!keep) size = null;
    syncSize(); prefetchNear();
  }
  var _pf = {};
  function prefetchNear() {
    // warm the current style's other inks + the other garment's current combo (low priority)
    getValidInks().forEach(function (t) { warm(imgUrl(g, effStyle(), effColor(), t)); });
    warm(imgUrl(g === 'tee' ? 'hoodie' : 'tee', effStyle(), effColor(), effInk()));
  }
  function getValidInks() { return vset(effStyle(), effColor()); }
  function warm(u) { if (!u || _pf[u]) return; _pf[u] = 1; var im = new Image(); im.decoding = 'async'; if ('fetchPriority' in im) im.fetchPriority = 'low'; im.src = u; }

  function garment(x) {
    g = x; el('pdp-gtee').className = (x === 'tee' ? 'on' : ''); el('pdp-ghood').className = (x === 'hoodie' ? 'on' : '');
    ensure(g, function () { if (prod()) { if (colorsOf().indexOf(color) < 0) color = colorsOf()[0]; if (stylesOf().indexOf(style) < 0) style = stylesOf()[0]; } sync(); });
  }
  function resetPDP() { style = CFG.defaultStyle; color = CFG.defaultColor; ink = 'fc'; size = null; styleChosen = false; colorChosen = false; inkChosen = false; garment('tee'); }

  function ensure(gar, cb) {
    if (DATA[gar]) { cb(); return; }
    // Use embedded variant data (server-rendered) — instant, no network fetch.
    if (CFG.variantData && CFG.variantData[gar] && CFG.variantData[gar].variants) {
      DATA[gar] = { variants: CFG.variantData[gar].variants };
      cb(); return;
    }
    var h = CFG.handles[gar]; if (!h) { cb(); return; }
    fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (j) {
      DATA[gar] = { variants: (j.variants || []).map(function (v) {
        return { color: v.option1, size: v.option2, style: v.option3, available: v.available, vid: v.id,
          price: (v.price / 100).toFixed(2), compare: (v.compare_at_price ? (v.compare_at_price / 100).toFixed(2) : null) }; }) };
      cb();
    }).catch(function () { cb(); });
  }

  function zOpen() { var z = el('pdp-zoom'); el('pdp-zoomimg').src = el('pdp-hero').src; z.classList.add('on'); }
  function zClose() { el('pdp-zoom').classList.remove('on'); }

  function wire() {
    el('pdp-gtee').onclick = function () { garment('tee'); };
    el('pdp-ghood').onclick = function () { garment('hoodie'); };
    el('pdp-reset').onclick = resetPDP;
    el('pdp-stage').addEventListener('click', zOpen);
    el('pdp-zoom').addEventListener('click', zClose);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') zClose(); });
    ensure('tee', function () {
      if (prod() && QV) { var qv = prod().variants.find(function (v) { return v.vid === QV; }); if (qv) { style = qv.style; color = qv.color; } }
      if (prod()) { if (colorsOf().indexOf(color) < 0) color = colorsOf()[0]; if (stylesOf().indexOf(style) < 0) style = stylesOf()[0]; }
      el('pdp-gtee').className = 'on'; sync(); scheduleReveal();
      setTimeout(warmAll, 200);
    });
    ensure('hoodie', function () {});
  }

  // Background-warm all combo images (decode into cache) so option swaps are instant.
  function warmAll() {
    try {
      if (!CFG.img) return;
      var cur = g + '|' + effStyle() + '|' + effColor() + '|' + effInk();
      var urls = [], seen = {};
      // current combo's siblings first (same garment), then everything else
      Object.keys(CFG.img).forEach(function (k) {
        var u = CFG.img[k]; if (!u || seen[u]) return; seen[u] = 1;
        urls.push({ u: u, pri: (k.split('|')[0] === g) ? 0 : 1 });
      });
      urls.sort(function (a, b) { return a.pri - b.pri; });
      var i = 0;
      function next() {
        if (i >= urls.length) return;
        var batch = urls.slice(i, i + 4); i += 4;
        var pending = batch.length;
        batch.forEach(function (o) {
          var im = new Image();
          im.onload = im.onerror = function () { if (--pending <= 0) setTimeout(next, 60); };
          im.src = o.u;
          if (im.decode) { im.decode().catch(function () {}); }
        });
      }
      next();
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire); else wire();
})();
